// removed by extract-text-webpack-plugin
module.exports = {"FailedContent":"FailedContent---24ZlI","Content":"Content---38_BL"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/Integration/OAuth/style.styl
// module id = sqON
// module chunks = 89